import { api, handleResponse, handleError } from './apiUtils';
import { LOGIN_URL } from '../global/Constants/user';

export function auth() {
  const LOGIN_URL = '/api/external/Common/Auth'; // Убедитесь, что URL правильный
  const loginData = {
    Login: "1", // Ваш логин
    Password: "1" // Ваш пароль
  };
  return api
    .post(LOGIN_URL, loginData) // Используем POST-запрос и передаем данные логина и пароля
    .then(handleResponse)
    .catch(handleError);
}

